import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import MainSidebar from "./Mainsidebar";
import { getSidebarOpen, subscribeSidebar } from "../Utils/sidebarState";

const DashboardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(getSidebarOpen);

  useEffect(() => {
    return subscribeSidebar((state) => {
      setIsSidebarOpen(state);
    });
  }, []);

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#fafbfe" }}>
      <MainSidebar hamburger={isSidebarOpen} sethamburger={setIsSidebarOpen} />

      {/* Main content – shifts right when sidebar is open */}
      <div
        style={{
          marginLeft: isSidebarOpen ? "15.5rem" : "0rem",
          transition: "margin-left 300ms ease-in-out",
          minHeight: "100vh",
          backgroundColor: "#fafbfe",
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;